export default {"src":"/_next/static/media/efficiency-icon.e0553de3.svg","height":93,"width":103,"blurWidth":0,"blurHeight":0};